import { render, staticRenderFns } from "./PageSearch.vue?vue&type=template&id=d8e3ceda&"
import script from "./PageSearch.vue?vue&type=script&lang=js&"
export * from "./PageSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports